import createIcon from '../../createIcon';

/**
 * @component @name SignalCellularAlt1Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuNSA5SDEzLjVWMTVIMTAuNVY5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalCellularAlt1Bar = createIcon('SignalCellularAlt1Bar', [
  ['path', { d: 'M10.5 9H13.5V15H10.5V9Z', key: '12213f' }],
]);

export default SignalCellularAlt1Bar;
